module.exports = __webpack_public_path__ + "static/Gilroy-Light-679cd8013e1e98981a3daa13995f5949.woff";